import React from 'react'
import { CheckClimaEl } from '../../style'
import { Dimmer, Loader } from 'semantic-ui-react'
import styled from 'styled-components'

interface Props {
  step: {
    icon?: string,
    title: string
    image?: string
    style?: any
  }
  active: boolean
  index: number
  isLoading?: boolean
  handleStepClick: () => void
  breed: boolean
  lastStepIndex: number
  isLoadingResults?: boolean
}

const StyledWrapper = styled.div<{ $active: boolean }>`
display: flex;
flex-direction: column;
align-items: center;
width: 150px;
`

const StyledDimmer = styled(Dimmer)`
margin-left: -3px !important;
background: transparent !important;
color: white;
 .loader {
    &:after {
      border-color: none !important;
    }
 }
`

const Step: React.FC<Props> = (props) => {

  const {
    step,
    active,
    index,
    isLoading,
    handleStepClick,
    breed,
    lastStepIndex,
    isLoadingResults
  } = props

  const isFirstStep = index === 0

  const isLastStep = index === lastStepIndex

  const clickable = false

  function renderSpinner() {
    return <StyledDimmer inverted active={isLoading}>
      <Loader active={isLoading} />
    </StyledDimmer>
  }

  function renderIcon() {
    return <div>
      <img src={step.image} style={props.step.style} />
    </div>
  }

  function renderStepContent() {
    return <StyledWrapper
      onClick={() => clickable && handleStepClick()}
      $active={active}
    >
      <CheckClimaEl.StepIcon
        $active={active}
        $dataLoaded={Boolean(clickable)}
      >
        {isLoading ? renderSpinner() : renderIcon()}
      </CheckClimaEl.StepIcon>
      <div
        style={{
          width: isFirstStep ? 'fit-content' : 'max-content',
          cursor: clickable ? 'pointer' : 'default'
        }}
        className='stepTitle'>
        {step.title}
      </div>
    </StyledWrapper>
  }

  return <CheckClimaEl.Step key={step.icon} $active={active} data-step={index}>
    {renderStepContent()}
  </CheckClimaEl.Step>
}
export default Step